import React from 'react';
import './Audio.css';

const Audio = () => {
  return (
    <section id="music" className="audio-section">
      <h2 className="section-title">Latest Sets</h2>
      <div className="audio-player-placeholder">
        <p>SoundCloud / Mixcloud Player Goes Here</p>
        <div className="waveform-placeholder"></div>
        <div className="controls-placeholder">
          <div className="play-button-placeholder"></div>
          <div className="track-info-placeholder">
            <span>Track Name - Artist</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Audio;
